import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { FormattedMessage } from 'react-intl';
import { Chapter } from '../app/infoModal/Chapter';

import { setActiveInfoModalChapter } from '../../routes/actions';
import { useLocation, useNavigate, useParams } from 'react-router';
import { getButtonTrackingAttributes } from '../../tracking/clickTracking';

export const InfoButton = (props: { appTitle: string }) => {
    const { appTitle } = props;

    const location = useLocation();
    const params = useParams();
    const push = useNavigate();

    const showInfoModal = (chapter: string) => setActiveInfoModalChapter(chapter, { location, params, push });

    const renderPopover = () => (
        <ActionBarItem.Popover title={appTitle}>
            <ActionBarItem.List>
                <ActionBarItem.ListItem
                    icon='rioglyph-hand-right'
                    onClick={() => showInfoModal(Chapter.WELCOME)}
                    {...getButtonTrackingAttributes(Chapter.WELCOME)}
                >
                    <FormattedMessage id='welcome.message' />
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    icon='rioglyph-group'
                    onClick={() => showInfoModal(Chapter.GROUPS)}
                    {...getButtonTrackingAttributes(Chapter.GROUPS)}
                >
                    <FormattedMessage id='concepts.message' />
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    icon='rioglyph-academic-cap '
                    onClick={() => showInfoModal(Chapter.INVITE_USER)}
                    {...getButtonTrackingAttributes(Chapter.INVITE_USER)}
                >
                    <FormattedMessage id='functions.message' />
                </ActionBarItem.ListItem>
            </ActionBarItem.List>
        </ActionBarItem.Popover>
    );

    return (
        <ActionBarItem id={'roleDescription'}>
            <ActionBarItem.Icon>
                <span
                    className={'icon rioglyph rioglyph-info-sign'}
                    {...getButtonTrackingAttributes('header.info.open')}
                />
            </ActionBarItem.Icon>
            {renderPopover()}
        </ActionBarItem>
    );
};
